import { render, staticRenderFns } from "./delete-report-modal.vue?vue&type=template&id=05c7c2cf&"
import script from "./delete-report-modal.vue?vue&type=script&lang=ts&"
export * from "./delete-report-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports